<a href="#" (click)="openFirmLookup()">Look up Firm License Number</a>
<mat-icon
  class="pl-small mt-xs smaller-icon"
  matTooltipClass="tooltip"
  matTooltipPosition="above"
  [matTooltip]="'Look up your firm\'s license number on ' + constants.acronym + '\'s site'"
  >help_outline</mat-icon
>
